module.exports = __webpack_public_path__ + "img/play_button.930a6eba.png";